import {
    SECONDS_IN_DAY,
    SECONDS_IN_HOUR,
    SECONDS_IN_MINUTE,
    TIME_AGO_UNITS,
} from '../constants';

/**
 * Returns a human-friendly relative time string like:
 *  - "Just now"
 *  - "5 minutes ago"
 *  - "2 hours ago"
 *  - "3 days ago"
 *
 * English-only for now, but strings are centralized for easy localization later.
 */
export function timeAgo(date?: Date | null): string {
    if (!date || isNaN(date.getTime())) return '';

    const now = Date.now();
    const diffMs = now - date.getTime();

    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffSeconds / SECONDS_IN_MINUTE);
    const diffHours = Math.floor(diffSeconds / SECONDS_IN_HOUR);
    const diffDays = Math.floor(diffSeconds / SECONDS_IN_DAY);

    if (diffSeconds < SECONDS_IN_MINUTE) {
        return TIME_AGO_UNITS.JUST_NOW;
    }

    if (diffMinutes < 60) {
        const unit =
            diffMinutes === 1 ? TIME_AGO_UNITS.MINUTE : TIME_AGO_UNITS.MINUTES;
        return `${diffMinutes} ${unit} ${TIME_AGO_UNITS.SUFFIX}`;
    }

    if (diffHours < 24) {
        const unit =
            diffHours === 1 ? TIME_AGO_UNITS.HOUR : TIME_AGO_UNITS.HOURS;
        return `${diffHours} ${unit} ${TIME_AGO_UNITS.SUFFIX}`;
    }

    const unit = diffDays === 1 ? TIME_AGO_UNITS.DAY : TIME_AGO_UNITS.DAYS;
    return `${diffDays} ${unit} ${TIME_AGO_UNITS.SUFFIX}`;
}
